export default "__VITE_ASSET__BwztT$Nr__"